<template>
    <div style="width: 100%">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span >当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="background-color: #FFFFFF">
            <el-form ref="form" :model="form" label-width="80px">
                <!-- 搜索类型 -->
                <el-form-item label="搜索类型:" style="margin-left: 20px">
                    <el-radio-group v-model="form.type" class="hide_input" @change="">
                        <el-radio label="0">商品SKU</el-radio>
                        <el-radio label="1">商品编码</el-radio>
                        <el-radio label="2">商品名称</el-radio>
                        <el-radio label="3">识别码</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!-- 搜索内容 -->
                <el-form-item label="搜索内容:" style="margin-left: 20px">
                    <el-input v-model="form.content" placeholder="多个sku间隔用逗号隔开"
                              style="width: 30%" size="small"></el-input>
                    <el-button type="primary" @click="search" style="margin-left: 10px" size="small">搜索</el-button>
                </el-form-item>
                <!-- 商品状态 -->
                <el-form-item label="商品状态:" style="margin-left: 20px">
                    <el-radio-group v-model="form.state" class="hide_input" @change="clickState">
                        <el-radio label="all">全部</el-radio>
                        <el-radio label="01">在售</el-radio>
                        <el-radio label="02">热销</el-radio>
                        <el-radio label="03">新品</el-radio>
                        <el-radio label="04">清仓</el-radio>
                        <el-radio label="05">停售</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!--商品分类-->
                <el-form-item label="商品分类" style="margin-left: 20px">
                    <TreeSelect :props="treeSelect" :options="dataList"  v-model="form.typeId" ref="childSelTree"
                                style="width: 30%;margin-right: 10px" @getValue="getTreeNodeId"></TreeSelect>
                </el-form-item>
                <!-- 排序类型 -->
                <el-form-item label="排序类型:" style="margin-left: 20px">
                    <el-radio-group v-model="form.sort" class="hide_input">
                        <el-radio label="CREATE_TIME">按创建时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="UPDATE_TIME">按更新时间<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                        <el-radio label="COMM_SKU">按商品SKU<i class="el-icon-caret-bottom" @click="turnWay"></i></el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <!-- 按钮组 -->
        <div style="margin-top: 20px">
            <el-row style="background-color: #EEEEEE">
                <el-col :span="2">
                    <el-dropdown placement="bottom-start" @command="batchHandle">
                        <el-button type="primary" size="small">
                            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">批量删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
                <el-col :span="2" style="margin-left: 15px">
                    <el-dropdown placement="bottom-start" trigger="click" ref="xxx">
                        <el-button size="small" type="primary" style="margin-left: 10px">移动分类<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                        <el-dropdown-menu slot="dropdown">
                            <div class="scro">
                                <el-scrollbar style="height: 200px">
                                    <el-tree style="text-align: center;margin-right: 15px" :data="ydlfTree.treeData" :props="ydlfTree.treeDefaultProps"
                                             @node-click="handleNodeClick" :default-expand-all="true" :expand-on-click-node="false"></el-tree>
                                </el-scrollbar>
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </div>
        <div style="margin-top: 10px">
            <el-radio-group v-model="form.commType" @change="clickCommType">
                <el-radio-button label="all">全部({{count.allCount}})</el-radio-button>
                <el-radio-button label="01">单品({{count.singleCount}})</el-radio-button>
                <el-radio-button label="02">多变种({{count.manyCount}})</el-radio-button>
            </el-radio-group>
        </div>
        <!-- 表格操作栏 -->
        <div style="">
            <el-row style="background-color: #FFFFFF;height: 50px">
                <!--<el-col :span="8"><br>库存总价值:{{money}}；库存总数：{{size}}</el-col>-->
                <el-col :span="8" style="text-align: right;margin-top: 8px">
                    <span style="color: #A2A2A2" v-show="form.commType=='02' && selectSkuSize>0">
                        已选择
                        <span v-show="selectCount>0" >
                            <span style="color: red">{{selectCount}}</span>条数据
                        </span>
                        <span v-show="selectSkuSize>0">
                            <span style="color: red">{{selectSkuSize}}</span>个sku
                        </span>
                    </span>
                    <span style="color: #A2A2A2" v-show="form.commType!='02' && totalSize>0">
                        已选择<span style="color: red">{{totalSize}}</span>条数据
                    </span>
                </el-col>
                <el-col :span="16" style="text-align: right;margin-top: 8px">
                    <el-button type="primary" @click="dialogVisible = true" size="small">导出</el-button>

                    <el-dropdown placement="bottom-start" @command="handleAddGoods">
                        <el-button type="warning" size="small">
                            添加商品<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="01">添加单个SKU</el-dropdown-item>
                            <el-dropdown-item command="02">添加多属性SKU</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
        </div>
        <!-- 商品表格 -->
        <div v-show="form.commType!='02'">
            <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;"
                      @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="40" align="center"></el-table-column>
                <el-table-column  prop="img" label="商品信息" width="350px" align="center">
                    <template slot-scope="scope">
                        <el-col :span="7">
                            <el-popover trigger="hover" title="" placement="right">
                                <img :src="scope.row.picUrl" width="300" height="300"/>
                                <img slot="reference"  :src="scope.row.picUrl" style="max-height: 100px;max-width: 100px;">
                            </el-popover>
                        </el-col>
                        <el-col :span="7" style="margin: auto;">
                            <div style="width: 250px;text-align: left;margin-left: 5px">商品SKU:{{scope.row.commSku}}</div>
                            <div style="width: 250px;text-align: left;margin-left: 5px">中文名称:{{scope.row.chinName}}</div>
                            <div style="width: 250px;text-align: left;margin-left: 5px">商品编码:{{scope.row.commId}}</div>
                            <div style="width: 250px;text-align: left;margin-left: 5px">备注:{{scope.row.remarks}}</div>
                        </el-col>
                    </template>
                </el-table-column>
                <el-table-column prop="refPrice" label="参考价￥" width="150" align="center">
                </el-table-column>
                <el-table-column prop="weight" label="重量g" width="150" align="center">
                </el-table-column>
                <el-table-column  label="尺寸cm" align="center">
                    <template scope="scope">
                        <span>{{scope.row.commLong}}*{{scope.row.commWide}}*{{scope.row.commHigh}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="commStatus" label="状态" align="center">
                </el-table-column>
                <el-table-column label="时间" align="left">
                    <template scope="scope">
                        <el-row>创建:</el-row>
                        <el-row>{{scope.row.createTime}}</el-row>
                        <el-row>更新:</el-row>
                        <el-row>{{scope.row.updateTime}}</el-row>
                    </template>
                </el-table-column>
                <el-table-column prop="handel" label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="singleSku(scope.row.commId)">编辑</el-button>
                        </br>
                        <el-button type="primary" size="mini" @click="openRemarkDiag(scope.row)" style="margin-top: 2px">备注
                        </el-button>
                        </br>
                        <el-button type="primary" size="mini" @click="deleteRow(scope.row)" style="margin-top: 2px">删除</el-button>
                        </br>

                    </template>
                </el-table-column>
                <el-table-column prop="id" label="ID" v-if="false"></el-table-column>
            </el-table>
            <!--<el-pagination background style="float: right;" @size-change="handleSizeChange"-->
                           <!--@current-change="handleCurrentChange"-->
                           <!--:current-page="currentPage" :page-sizes="[1, 5, 300, 400]" :page-size="100"-->
                           <!--layout="total, sizes, prev, pager, next, jumper"-->
                           <!--:total="400">-->
            <!--</el-pagination>-->
            <pagination
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="getList"
            />
        </div>
        <!-- 导出弹出框 -->
        <el-dialog :close-on-click-modal="false"  
                title="导出图片"
                :visible.sync="dialogVisible"
                width="30%">
            <span>已导出:<font style="color: red">XX</font></span><br>
            <span>导出文件已生成，请立即下载！</span><br>
            <div>
                <el-progress :text-inside="true" :stroke-width="24" :percentage="100" status="success"></el-progress>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogVisible = false">下 载</el-button>
            </span>
        </el-dialog>
        <!-- 备注弹出框 -->
        <el-dialog :close-on-click-modal="false"   title="添加备注" width="35%" :visible.sync="dialogFormVisible" class="note-dialog">
            <el-row style="display: flex;align-items: center">
                <el-col :span="2">
                    <p>内容:</p>
                </el-col>
                <el-col :span="22">
                    <el-input v-model="form.remarks"  placeholder="请输入介绍信息" type="textarea" :rows="10">

                    </el-input>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="submitRemark" size="small">确 定</el-button>
            </div>
        </el-dialog>
        <!--多属性的表格-->
        <div v-show="form.commType=='02'">
            <vxe-table
                    border
                    resizable
                    row-id="commId"
                    :tree-config="{lazy: true, children: 'children', hasChild: 'hasChild',loadMethod: loadChildrenMethod, iconOpen: 'fa fa-minus-square-o', iconClose: 'fa fa-plus-square-o'}"
                    :data="tableData1"
                    @checkbox-change="selectionChange"
                    @checkbox-all="selectAll">
                <vxe-table-column type="checkbox"  width="80" tree-node>
                </vxe-table-column>
                <vxe-table-column  title="图片" width="90">
                    <template v-slot="{ row }">
                        <img v-if="row.picUrl" :src="row.picUrl" style="width: 60px;">
                        <span v-else>无</span>
                    </template>
                </vxe-table-column>
                <vxe-table-column  title="商品信息" width="250">
                    <template v-slot="{ row }">
                        <el-row v-show="row.commSpu!=null">
                            <el-col :span="8" style="color: red">
                                商品SPU:
                            </el-col>
                            <el-col :span="10">
                                {{row.commSpu}}
                            </el-col>
                        </el-row>
                        <!---->
                        <el-row v-show="row.commSpu==null">
                            <el-col :span="8">
                                商品SKU:
                            </el-col>
                            <el-col :span="10">
                                {{row.commSku}}
                            </el-col>
                        </el-row>
                        <!---->
                        <el-row>
                            <el-col :span="8">
                                中文名称:
                            </el-col>
                            <el-col :span="10">
                                {{row.chinName}}
                            </el-col>
                        </el-row>
                        <!---->
                        <el-row>
                            <el-col :span="8">
                                商品编码:
                            </el-col>
                            <el-col :span="10">
                                {{row.commId}}
                            </el-col>
                        </el-row>
                        <!---->
                        <el-row>
                            <el-col :span="8">
                                备注:
                            </el-col>
                            <el-col :span="10">
                                {{row.remarks}}
                            </el-col>
                        </el-row>
                    </template>
                </vxe-table-column>
                <vxe-table-column  title="参考价￥">
                    <template v-slot="{ row }">
                        <div v-show="row.commSpu==null">
                            {{row.refPrice}}
                        </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column  title="重量g">
                    <template v-slot="{ row }">
                        <div v-show="row.commSpu==null">
                            {{row.weight}}
                        </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column  title="尺寸cm">
                    <template v-slot="{ row }">
                        <div v-show="row.commSpu==null">
                            <span>{{row.commLong}}*{{row.commWide}}*{{row.commHigh}}</span>
                        </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column  title="状态">
                    <template v-slot="{ row }">
                        <div v-show="row.commSpu==null">
                            {{row.commStatus}}
                        </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column  title="时间">
                    <template v-slot="{ row }">
                        <div v-show="row.commSpu==null">
                            <el-row>创建:</el-row>
                            <el-row>{{row.createTime}}</el-row>
                            <el-row>更新:</el-row>
                            <el-row>{{row.updateTime}}</el-row>
                        </div>
                    </template>
                </vxe-table-column>
                <vxe-table-column  title="操作">
                    <template v-slot="{ row }">
                        <div v-if="row.commSpu!=null">
                            <el-link type="primary" @click="manySku(row.commId)">编辑</el-link><br>
                            <el-link type="primary" @click="deleteAllData(row)">删除</el-link>
                        </div>
                        <div v-else>
                            <el-link type="primary" @click="singleSku(row.commId)">编辑</el-link><br>
                            <el-link type="primary" @click="openRemarkDiag(row)">备注</el-link><br>
                            <el-link type="primary" @click="deleteRow(row)">删除</el-link>
                        </div>
                    </template>
                </vxe-table-column>
            </vxe-table>
            <pagination
                    :total="total"
                    :page.sync="form.pageNum"
                    :limit.sync="form.pageSize"
                    @pagination="getManyListById"
            />
        </div>


    </div>
</template>

<script>
    import TreeSelect from '@/components/common/treeSelect';
    import {loadDataMap,getClickTree} from '@/api/store/commType'
    import {getGoodsList,batchDelete,batchUpdate,updateRemark,getAllTypeCount,getManyListById,getManyChildListById,getChildrenId,deleteCommIdAllData} from '@/api/store/storeManage';
    import {getTree} from '@/api/tree/tree';
    import ElRow from "element-ui/packages/row/src/row";
    export default {
        //注册组件
        components: {
            ElRow,
            TreeSelect,
        },
        data: function () {
            return {
                tableData1:[
                    // {
                    //     commId:'7',
                    //     commStatus:20,
                    //     picUrl:'https://xuliangzhan_admin.gitee.io/vxe-table/static/other/img1.gif',
                    //     hasChild:true,
                    //     // children:[],
                    // }
                ],
                total: 10,
                radio2: '1',
                money: '15.00 元',
                size: '5',
                totalSize: 0,
                bb: false,
                ids:[],
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    type: '0',
                    content: '',
                    state: 'all',
                    sort: 'CREATE_TIME',
                    byAsc:'desc',
                    typeId:null,
                    remarks:null,
                    commId:null,
                    commType:'all',
                },
                count:{
                    allCount:0,
                    singleCount:0,
                    manyCount:0,
                },
                currentPage: 1,
                tableData: [],
                dialogVisible: false,
                ydlfTree:{
                    treeData: [],
                    treeDefaultProps: {
                        children: 'children',
                        label: 'label',
                        value:'value',
                        pCatId:'pCatId'
                    },
                },
                //表格下拉框
                options: [{
                    value: '1',
                    label: '在售'
                }, {
                    value: '2',
                    label: '热销'
                }, {
                    value: '3',
                    label: '新品'
                }, {
                    value: '4',
                    label: '清仓'
                }, {
                    value: '5',
                    label: '停售'
                }],
                value: '停售',
                gridData: [{
                    date: 'A仓库',
                    name: '11',
                    address: '25'
                }, {
                    date: 'B仓库',
                    name: '12',
                    address: '35'
                }, {
                    date: 'C仓库',
                    name: '13',
                    address: '45'
                }, {
                    date: 'D仓库',
                    name: '17',
                    address: '55'
                }],
                // 备注框
                dialogFormVisible: false,
                formLabelWidth: '45px',
                //下拉树
                treeSelect: {
                    value: 'id',
                    label: 'name',
                    children: 'children',
                    pCatId:'pCatId',
                },
                //树形数据
                dataList:[],
                selectCount:0, //数据条数
                selectSkuSize:0,  //SKU条数

            };
        },
        created() {
            var that = this;
            that.getTree(that);
            that.getList();
            that.getMoveClassification();
            that.getAllTypeCount();
            // that.getManyListById();
        },
        methods: {
            //获取表格数据
            getList(){
                var param = this.form;
                param['primUserNo']= this.$store.state.user.name;
                getGoodsList(param).then((res) => {
                    this.tableData=res.rows
                    this.total = res.total
                })
            },
            handleSelectionChange: function (val) {
                this.ids=[];
                val.forEach((item) => {
                    this.ids.push(item.commId);
                });
                this.totalSize = val.length;
                // this.$message({
                //   message: '选择提示:已选择' + val.length + '条',
                //   center: true,
                //   offset: 200
                // });
            },
            handleSizeChange: function (val) {
                console.log(`每页: ${val}条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            move() {
                //直接跳转
                this.$router.replace('/tjsp')
            },
            edit() {

            },
            onSubmit() {

            },
            handleNodeClick() {

            },
            //编辑
            edit(index, row, fieldState) {
                this.value;
                if (fieldState == 'weightState') {
                    row.weightState = true;
                }
                if (fieldState == 'priceState') {
                    row.priceState = true;
                }
                if (fieldState == 'sizeState') {
                    row.sizeState = true;
                }

            },
            //保存
            save(index, row, fieldState) {
                if (fieldState == 'weightState') {
                    row.weight = row.weight
                    row.weightState = false;
                }
                if (fieldState == 'priceState') {
                    row.price = row.price
                    row.priceState = false;
                }
                if (fieldState == 'sizeState') {
                    row.size = row.size;
                    row.size2 = row.size2;
                    row.size3 = row.size3;
                    row.sizeState = false;
                }
            },
            //取消
            cancel(index, row, fieldState) {
                if (fieldState == 'weightState') {
                    row.weightState = false;
                }
                if (fieldState == 'priceState') {
                    row.priceState = false;
                }
                if (fieldState == 'sizeState') {
                    row.sizeState = false;
                }
            },
            //排序类型的箭头变动
            turnWay(e){
                var classVal =  e.target.className;
                if(classVal == 'el-icon-caret-top'){
                    e.target.setAttribute('class','el-icon-caret-bottom');
                    this.form.byAsc = 'desc';
                }else{
                    e.target.setAttribute('class','el-icon-caret-top');
                    this.form.byAsc = 'asc';
                }
                this.getList()

            },
            //获取本平台树的ID
            getTreeNodeId(val){
                this.form.typeId=val;
                var commType = this.form.commType;
                if (commType==='02'){
                    this.getManyListById();
                }else{
                    this.getList();
                }
            },
            getTree(that){
                // 获取本平台树
                loadDataMap().then((res) => {
                    that.dataList=that.optionData(res.data);
                    setTimeout(function () {
                        that.$refs.childSelTree.initHandle();
                    },100);
                })
            },
            //处理tree的数据
            optionData(data) {
                let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
                return cloneData.filter(father => {                      // 循环所有项，并添加children属性
                    let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
                    branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
                    return father.parentId == 0;      //返回第一层
                });
            },
            //点击商品状态查询
            clickState(e){
                var commType = this.form.commType;
                if (commType==='02'){
                    this.getManyListById();
                }else{
                    this.getList();
                }
            },
            //搜索
            search(){
                var commType = this.form.commType;
                if (commType==='02'){
                    this.getManyListById();
                }else{
                    this.getList();
                }
            },
            //批量操作选择
            batchHandle(val){
                if (val==1){
                    this.batchDelete();
                }
            },
            //删除单条数据
            deleteRow(row){
                var ids = [];
                ids.push(row.commId);
                this.$confirm('是否确认删除该条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchDelete(ids);
                }).then(() => {
                    var commType = this.form.commType;
                    if (commType==='02'){
                        this.getManyListById();
                    }else{
                        this.getList();
                    }
                    this.msgSuccess("删除成功");
                }).catch(function() {});
            },
            batchDelete(){
                var size = this.ids.length;
                var ids = this.ids;
                if (size<=0){
                    this.msgError("请选择需要删除的商品数据");
                    return
                }
                this.$confirm('是否确认删除选择的' + size + '条数据项?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(function() {
                    return batchDelete(ids);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("删除成功");
                }).catch(function() {});
            },
            //点击移入分类的tree
            handleNodeClick(val) {
                var id = val.value;
                var size = this.ids.length;
                if (size<=0){
                    this.msgError("请选择需要移动分类的商品数据");
                    return
                }
                var param ={
                    'ids':this.ids.join(","),
                    'typeId':id,
                }
                this.$confirm('是否确认把选择的' + size + '条数据项移入<span style="color: red">'+val.name+'</span>分类?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    //显示HTML
                    dangerouslyUseHTMLString: true,
                    type: "warning"
                }).then(function() {
                    return batchUpdate(param);
                }).then(() => {
                    this.getList();
                    this.msgSuccess("移动分类成功");
                }).catch(function() {});

            },
            //移动分类树形数据
            getMoveClassification(){
                getClickTree().then((res) => {
                    this.ydlfTree.treeData=res.data;
                })
            },
            //提交备注
            submitRemark(){
                var param={
                    'remark':this.form.remarks,
                    'commId':this.form.commId,
                }
                updateRemark(param).then((res) => {
                    var commType = this.form.commType;
                    if (commType==='02'){
                        this.getManyListById();
                    }else{
                        this.getList();
                    }
                    this.msgSuccess("修改成功");
                    this.dialogFormVisible = false;
                })
            },
            //打开备注框
            openRemarkDiag(row){
                this.dialogFormVisible = true;
                this.form.remarks =row.remarks
                this.form.commId =row.commId
            },
            //点击商品变种
            clickCommType(e){
                let commType = this.form.commType;
                if (commType==='02'){
                    this.getManyListById();
                }else{
                    this.getList();
                }
            },
            //查询全部,单品,多变种的数量
            getAllTypeCount(){
                getAllTypeCount().then((res) => {
                   this.count.allCount= res.data.allCount;
                    this.count.singleCount= res.data.singleCount;
                    this.count.manyCount= res.data.manyCount;
                })
            },
            //查询所有的父商品
            getManyListById(){
                var param = this.form;
                param['primUserNo']= this.$store.state.user.name;
                getManyListById(param).then((res) => {
                    this.tableData1=res.rows;
                    this.total = res.total
                })
            },
            loadChildrenMethod ({ row }) {
                var param = this.form;
                param['primUserNo']= this.$store.state.user.name;
                param['commPId']= row.commId;
                // 异步加载子节点
                return new Promise(resolve => {
                    getManyChildListById(param).then((res) => {
                        resolve(res.data);
                   })
                })

            },
            //选择表格
            selectionChange({selection}) {
                // console.log('单选',selection.length)
                this.ids=[];
                this.selectCount=0;
                this.selectSkuSize=0;
                var ids="";
                for(var i=0 ; i<selection.length; i++){
                    var children = selection[i].children;
                    var hasChild = selection[i].hasChild;
                    var commId = selection[i].commId;
                    //没有加载过的父级(要记录总条数和SKU数量)
                    if (children===null &&hasChild==1){
                        ++this.selectCount
                        ids+=commId+",";
                        //(要记录总条数)
                    }else if(children!=undefined && children.length>0){
                        ++this.selectCount
                        //记录SKU数量
                    }else{
                        ++this.selectSkuSize;
                    }
                    this.ids.push(selection[i].commId);
                }
                var param={
                    'commIds':ids
                }
                //查找sku数量
                getChildrenId(param).then((res) => {
                    this.selectSkuSize+=res.data.length;
                    let selectSkuSize = this.selectSkuSize;
                    //合并数组
                    var concat = this.ids.concat(res.data);
                    //赋值
                    this.ids=concat;
                })
            },
            // 选择所有
            selectAll({selection}){
                this.ids=[];
                this.selectCount=0;
                var ids="";
                for(var i=0 ; i<selection.length; i++){
                    if (selection[i].hasChild==1){
                        ids+=selection[i].commId+",";
                        this.ids.push(selection[i].commId);
                        this.selectCount=++this.selectCount;
                    }
                }
                var param={
                    'commIds':ids
                }
                getChildrenId(param).then((res) => {
                    this.selectSkuSize=res.data.length;
                    //合并数组
                    var concat = this.ids.concat(res.data);
                    //赋值
                    this.ids=concat;
                })
            },
            //根据父ID,删除所有的子商品和本身
            deleteAllData(row){
                var commId = row.commId;
                this.$confirm('是否确认删除改数据和该数据下的子商品?', "警告", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    //显示HTML
                    dangerouslyUseHTMLString: true,
                    type: "warning"
                }).then(function() {
                    return deleteCommIdAllData(commId);
                }).then(() => {
                    this.getManyListById();
                    this.msgSuccess("删除成功");
                }).catch(function() {});
            },
            //处理单个还是多属性添加商品
            handleAddGoods(e){
                if (e=='02'){
                    this.$router.push({path:"/repository/manage/addManyGoods",query:{}})
                } else if(e=='01'){
                    this.$router.push({path:"/repository/manage/addSingleGoods",query:{}})
                }
            },
            //多属性编辑
            manySku(commId){
                this.$router.push({path:"/repository/manage/editManyGoods",query:{'commId':commId}})
            },
            //单属性编辑
            singleSku(commId){
                this.$router.push({path:"/repository/manage/editSingleGoods",query:{'commId':commId}})
            }
        }
    }
</script>

<style scoped>
    @import '../../../assets/css/product.css';
    /*去除按钮的左边框*/
    /*.searchType .el-radio-button:first-child .el-radio-button__inner {*/
        /*border-left: 0px solid #DCDFE6;*/
    /*}*/
    /*去除按钮的边框*/
    .searchType .el-radio-button__inner {
        border: 0px solid #DCDFE6;
    }
    .scro >>> .el-scrollbar__wrap {
        overflow-x: hidden;
    }
</style>
